export default {
    userRoleName: {
        participant: "default",
        eventAdmin: "event_admin",
        admin: "admin"
    },
    announcement_types:[
        "system",
        "event",
        "session",
        "sport",
        "sport_item"
    ]
}



// WEBPACK FOOTER //
// ./src/libs/enums.js